import {Button, Dialog, DialogActions, TextField, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

/**
 * @param {Object} props
 * @param {boolean} props.open
 * @param {string} props.ariaLabelledby
 * @param {string} props.id
 * @param {string} props.label
 * @param {number} props.rows
 * @param {string} props.defaultValue
 * @param {string} props.variant
 * @param {Object} props.style
 * @param {function(string)} props.handleClose
 * @return {JSX.Element}
 * @constructor
 */
export function BCPDataGridTextFieldDialog(props) {
    const textFieldRef = React.useRef();

    return (
        <Dialog
            onClose={props.handleClose}
            open={props.open}
            aria-labelledby={props.ariaLabelledby}>
            <DialogTitle className='datagrid-dialog-closeIconContainer'>
                <IconButton onClick={props.handleClose}>
                    <CloseIcon fontSize='large' />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography className='datagrid-dialog-title'><b>{props.title}</b></Typography>
                <TextField
                    id={props.id}
                    hiddenLabel={true}
                    multiline
                    fullWidth
                    placeholder='Text'
                    rows={props.rows}
                    defaultValue={props.defaultValue}
                    variant={props.variant}
                    inputRef={textFieldRef}
                />
            </DialogContent>
            <DialogActions>
                <div className='popup-save-button-container'>
                    <Button
                        className='popup-save-button'
                        variant='contained'
                        onClick={()=>{props.handleClose(textFieldRef.current.value);}}
                    >Save</Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

BCPDataGridTextFieldDialog.propTypes = {
    open: PropTypes.bool,
    ariaLabelledby: PropTypes.string,
    id: PropTypes.string,
    title: PropTypes.string,
    rows: PropTypes.number,
    defaultValue: PropTypes.string,
    variant: PropTypes.string,
    style: PropTypes.object,
    handleClose: PropTypes.func,
};

